import { Box, Stack, Typography, useTheme } from '@mui/material';

import LayoutContainer from 'components/LayoutContainer';
import Logo from 'layout/NavBarWithContent/NavBar/Logo';
import { panelBorder } from 'theme/colors';

import ContactDetails from './ContactDetails';

const Footer: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexShrink: 0 }}>
      <LayoutContainer
        sx={{
          py: { xs: 3, md: 5 },
          borderTop: panelBorder,
        }}
      >
        <Box
          display='grid'
          gridTemplateColumns='1fr auto'
          gap={1}
          sx={{
            [theme.breakpoints.down('sm')]: {
              gridTemplateColumns: 'repeat(1, 1fr)',
              gap: 3,
            },
          }}
        >
          <Box gridColumn='span 1' sx={{ minWidth: 0 }}>
            <Stack spacing={2.5} sx={{ alignItems: 'flex-start' }}>
              <Logo />
              <Typography variant='p3' sx={{ color: 'typography.light', opacity: 0.65, maxWidth: '32ch' }}>
                Luotettavaa autohuoltoa Jyväskylän Seppälänkankaalla.
              </Typography>
            </Stack>
          </Box>
          <Box gridColumn='span 1' sx={{ minWidth: 0 }}>
            <ContactDetails />
          </Box>
        </Box>
      </LayoutContainer>
    </Box>
  );
};

export default Footer;
